<template>
  <div class="flex flex-grow">
    <SearchEmptyResults :departure-dates="searchParams.dates">
      <FreeButton
        class="green-main-button absolute bottom-4 w-full font-semibold"
        @click="openChangeDates"
      >
        {{ t('search.emptyResults.selectNewDates') }}
      </FreeButton>
    </SearchEmptyResults>

    <FreeBottomSheet v-if="isMultiTripSearch" :name="searchFormBottomSheetName">
      <template #header="{ hide }">
        <FreeHeader class="px-4 pt-4">
          <h2 class="text-text-neutral-primary text-base font-medium">
            {{ t('general.search') }}
          </h2>
          <template #rightAction>
            <FreeCloseButton class="gray-header-close-button" @click="hide" />
          </template>
        </FreeHeader>
      </template>
      <template #default>
        <div class="p-4">
          <SearchForm
            source="search_page"
            @onSearchFormSubmit="onSearchFormSubmit"
          />
        </div>
      </template>
    </FreeBottomSheet>
    <SearchCalendar
      v-else
      :cabin-class="searchParams.cabinClass"
      :is-youth="searchParams.isYouth"
      :passengers="searchParams.passengers"
      :selected-dates="searchParams.dates"
      :name="calendarBottomSheetName"
      @onDatesSelected="onCalendarDatesSelected"
      @onSelectAirline="selectedAirlineIata = $event?.iata ?? null"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import {
    FreeButton,
    FreeBottomSheet,
    FreeHeader,
    FreeCloseButton,
  } from 'freedom-shared';
  import { controllerModel, hashCodeLib } from 'shared';

  import { SearchForm } from '@/widgets/search-form';
  import { SearchEmptyResults } from '@/widgets/search-empty-results';
  import { SearchCalendar } from '@/widgets/search-calendar';

  const emit = defineEmits<{
    onDatesSelect: [newDates: string[], airlineIata?: string];
    onSearchFormSubmit: [searchParams: string, airlineIata?: string];
  }>();

  const props = defineProps<{
    hashCode: string;
  }>();

  const { t } = useI18n();

  const calendarBottomSheetName = 'empty-results-bottom-sheet';
  const searchFormBottomSheetName = 'empty-results-search-form-bottom-sheet';
  const bottomSheet = controllerModel.useBottomSheet();

  const searchParams = computed(() =>
    hashCodeLib.getSearchParams(props.hashCode),
  );

  const isMultiTripSearch = computed(() =>
    hashCodeLib.isMultiTripSearch(props.hashCode),
  );

  const openChangeDates = () => {
    if (isMultiTripSearch.value) {
      bottomSheet.show(searchFormBottomSheetName);
    } else {
      bottomSheet.show(calendarBottomSheetName);
    }
  };

  const selectedAirlineIata = ref<string | null>(null);

  const onCalendarDatesSelected = (newDates: string[]) => {
    emit('onDatesSelect', newDates, selectedAirlineIata.value ?? undefined);
    selectedAirlineIata.value = null;
  };

  const onSearchFormSubmit = (searchQuery: string, airlineIata?: string) => {
    bottomSheet.hide(searchFormBottomSheetName);
    emit('onSearchFormSubmit', searchQuery, airlineIata);
  };
</script>
